import { Badge } from '@bbpos/ui';
import type { TenantStatus } from '@/types/tenant';

const STATUS_CONFIG: Record<TenantStatus, { variant: string; label: string }> = {
  ACTIVE: { variant: 'success', label: 'Active' },
  TRIAL: { variant: 'info', label: 'Trial' },
  PENDING_APPROVAL: { variant: 'warning', label: 'Pending Approval' },
  APPROVED: { variant: 'info', label: 'Approved' },
  PROVISIONED: { variant: 'info', label: 'Provisioned' },
  SUSPENDED: { variant: 'danger', label: 'Suspended' },
  CANCELLED: { variant: 'draft', label: 'Cancelled' },
  CHURNED: { variant: 'draft', label: 'Churned' },
};

interface TenantStatusBadgeProps {
  status: TenantStatus;
}

export function TenantStatusBadge({ status }: TenantStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? { variant: 'default', label: status };
  return <Badge variant={config.variant as never}>{config.label}</Badge>;
}
